import React from "react";

import { isEmpty } from "lodash";
import propTypes from "prop-types";
import cx from "classnames";

import imageStore from "../../zustand/image.store";

import styles from "./thumbNail.module.scss";

const ThumbNail = ({ name, color, className, imgSrc, photoString }) => {
  const { donwloadedImges } = imageStore((state) => ({
    donwloadedImges: state.donwloadedImges,
  }));

  const isImageDonwloaded = donwloadedImges?.[imgSrc] || false;

  return (
    <div
      className={cx(styles.thumbNail, className)}
      style={{ backgroundColor: isImageDonwloaded ? "transparent" : color }}
    >
      {isImageDonwloaded ? (
        <div className={styles.imageContainer}>
          <img src={imgSrc} alt="pending" crossOrigin="anonymous" />
        </div>
      ) : !isEmpty(photoString) ? (
        <img
          src={photoString}
          alt="img"
          style={{
            height: "100%",
            width: "100%",
            objectFit: "contain",
          }}
        />
      ) : (
        <p>{name[0]}</p>
      )}
    </div>
  );
};

ThumbNail.propTypes = {
  name: propTypes.string,
  color: propTypes.string,
  className: propTypes.string,
  hasImage: propTypes.bool,
};

ThumbNail.defaultProps = {
  name: "",
  color: "#BC589A",
  className: "",
  hasImage: false,
};

export default ThumbNail;
